import GoogleAnalytics from "./client";

GoogleAnalytics("UA-158625357-3");
